export const TBL_HEADERS = [
  {
    name: "Actions",
    variable: "",
  },
  {
    name: "Instrument Code",
    variable: "testType",
  },
  {
    name: "Drug Class",
    variable: "labId",
  },
  {
    name: "Specimen Type",
    variable: "resultMethod",
  },
  {
    name: "QC Level",
    variable: "testCode",
  },
  {
    name: "Target",
    variable: "tmitCode",
  },
  {
    name: "Calculation",
    variable: "tmitCode",
  },
];
